module.exports = __webpack_public_path__ + "end-device-placeholder.83c4892911496716542883dfe1bb0a44.svg";